/**
 * Kurul puanlama — 5 kriter (el kaldırma / karşılaştırmalı toplantı).
 * Ağırlıklar konuya göre odulOneriScoring.js içinde seçilir.
 */

export const BOARD_CRITERIA = [
  {
    id: 'yenilik',
    title: 'Yenilik',
    shortTitle: 'Yenilik',
    question:
      'Uygulanan çözüm, mevcut uygulamadan ne ölçüde farklı ve geliştirici bir iyileştirme sağlıyor?',
    levels: [
      'Yenilik yok',
      'Küçük düzenleme',
      'Belirgin geliştirme',
      'Yeni yöntem',
      'Bölüm için önemli yenilik',
      'Özgün ve örnek fikir',
    ],
  },
  {
    id: 'kalite',
    title: 'Kalite / Hata / Hurda Etkisi',
    shortTitle: 'Kalite / Hurda',
    question:
      'Uygulama, OPEX tarafından doğrulanan sonuçlarda kaliteyi iyileştirip hata, hurda ya da yeniden işlemeyi ne ölçüde azalttı?',
    levels: [
      'Kaliteyi bozuyor veya hata/hurdayı artırıyor',
      'Ölçülebilir etkisi yok',
      'Sınırlı ve lokal iyileşme',
      'Orta düzeyde ölçülebilir iyileşme',
      'Belirgin ve önemli iyileşme',
      'Kritik kalite sorununu veya kronik hurdayı ortadan kaldırıyor',
    ],
  },
  {
    id: 'verimlilik',
    title: 'Verimlilik / Maliyet / Kaynak Kullanımı',
    shortTitle: 'Verimlilik / Maliyet',
    question:
      'Gerçekleşen uygulama; süre, iş gücü, maliyet veya kaynak kullanımında ne ölçüde doğrulanmış iyileşme sağladı?',
    levels: [
      'Süreyi, maliyeti veya kaynak tüketimini artırıyor',
      'Ölçülebilir etkisi yok',
      'Sınırlı ve lokal tasarruf',
      'Orta düzeyde ölçülebilir tasarruf',
      'Belirgin ve sürdürülebilir kazanç',
      'Büyük ve stratejik kazanç',
    ],
  },
  {
    id: 'isg',
    title: 'İSG / Ergonomi',
    shortTitle: 'İSG / Ergonomi',
    question:
      'Uygulama, sahada iş kazası riskini veya çalışan üzerindeki ergonomik yükü ne ölçüde azalttı?',
    levels: [
      'İSG riskini artırıyor',
      'İSG veya ergonomiye etkisi yok',
      'Düşük risk veya ergonomi iyileşmesi',
      'Orta düzey risk veya ergonomi iyileşmesi',
      'Yaralanma riskini önemli ölçüde azaltıyor',
      'Ciddi yaralanma veya ölüm riskini ortadan kaldırıyor',
    ],
  },
  {
    id: 'yayginlastirma',
    title: 'Yaygınlaştırma',
    shortTitle: 'Yaygınlaştırma',
    question:
      'Doğrulanmış uygulama sonucu başka makine, hat veya bölümlere ne ölçüde yaygınlaştırılabilir?',
    levels: [
      'Başka noktaya uygulanamaz',
      'Tek iş noktasında veya üründe',
      'Aynı makinede veya benzer ürünlerde',
      'Aynı hat veya bölümde',
      'Birden fazla hat veya bölümde',
      'Fabrika veya şirket genelinde',
    ],
  },
]

export const BOARD_ROLE_LABELS = {
  baskan: 'Kurul Başkanı',
  uye: 'Üye',
}

export const getBoardRoleLabel = (role) => {
  if (role == null || role === '') return BOARD_ROLE_LABELS.uye
  const key = String(role).trim().toLocaleLowerCase('tr-TR')
  if (
    key === 'baskan' ||
    key === 'board_chair' ||
    key === 'başkan' ||
    key === 'kurul başkanı'
  ) {
    return BOARD_ROLE_LABELS.baskan
  }
  return BOARD_ROLE_LABELS.uye
}
